import React from 'react';

import LegacyPriceColumn from '@rover/components/src/cards/SearchResultCard/PriceColumn/LegacyPriceColumn';
import { Locale } from '@rover/constants/src/i18n/lingui.constants';
import { Flex, Text } from '@rover/kibble/core';
import type { TrainerSearchResult } from '@rover/rsdk/src/apiClient/latest/model/trainerSearchResult';
import { PriceTransparencyLevels } from '@rover/types/src/PriceTransparencyLevel';

import AvatarWithBadge from '../../CarouselSitterCard/components/AvatarWithBadge';

export type Props = {
  searchResult: TrainerSearchResult;
  shouldUsePriceTransparency?: boolean;
  locale: Locale;
  currencyCode: string;
};

const ProfileNameAndPriceRow: React.FC<Props> = ({
  searchResult,
  shouldUsePriceTransparency,
  locale,
  currencyCode,
}: Props) => {
  const { defaultImage, price, shortName, unitAsSentence, primaryBadgeData } = searchResult;
  // DEV-104195: Translate
  const description = `Trainer Profile Image: ${shortName}`;

  return (
    <Flex gap="4x" flexDirection="row" justifyContent="space-between" alignItems="center">
      <Flex gap="4x" flexDirection="row" alignItems="center">
        <AvatarWithBadge
          imageUrl={defaultImage}
          badge={primaryBadgeData}
          shortName={shortName}
          description={description}
        />
        <Flex gap="1x" flexDirection="column">
          <Text itemProp="name" textColor="primary" size="200" fontWeight="semibold">
            {shortName}
          </Text>
        </Flex>
      </Flex>

      <LegacyPriceColumn
        price={price}
        unitAsSentence={unitAsSentence}
        priceTransparencyLevel={
          shouldUsePriceTransparency ? PriceTransparencyLevels.full : PriceTransparencyLevels.none
        }
        locale={locale}
        currencyCode={currencyCode}
        isTrainingDesign
      />
    </Flex>
  );
};

export default ProfileNameAndPriceRow;
